module.exports = __webpack_public_path__ + "media/packs/landing_page/images/activities/funcional-c1bed93a2f011a348a304abf46fdc500.png";